import React, { Fragment, Component } from 'react';
import {BrowserRouter, Route } from 'react-router-dom'
import axios from 'axios'
import store from './store'
import Top from './components/top'
import Footer from './components/footer'
import Topic from './components/topic'
import First    from './pages/first'
import Company  from './pages/company'
import Contact  from './pages/contact'
import Customer from './pages/customer'
import Product  from './pages/product'

class App extends Component {
  render(){
    return (
      <Fragment>
        <BrowserRouter>
          <Top />
          <Topic />
          <Route path='/' exact   component={First} />
          <Route path='/company'  component={Company} />
          <Route path='/contact'  component={Contact} />
          <Route path='/customer' component={Customer} />
          <Route path='/product'  component={Product} />
        </BrowserRouter>
        <Footer />
      </Fragment>
    );
  }
  componentWillMount() {
    axios.get('/api/lkd.json').then((res)=>{
      const action = {type: 'get_lkd',value: res.data};
      store.dispatch(action);
      console.log(store.getState());
    }).catch((err)=>{
      console.log(err);
    });
  }
}

export default App;
